/* tslint:disable:component-selector import-spacing no-trailing-whitespace no-inferrable-types */
import {
  Component,
  AfterViewInit
}                          from '@angular/core';

import {first}             from "rxjs/operators";

import {Logger}            from '@/util/logger';

import {BlobService}       from '@/services/blob.service';

import {NumberEditor}      from '@/helpers/number.editor';
import {NumberRenderer}    from '@/helpers/number.renderer';
import {KPI}               from "@/models/k.p.i";

//import * as $ from 'jquery';
declare var $:JQueryStatic;

import 'gasparesganga-jquery-loading-overlay';  /* https://gasparesganga.com/labs/jquery-loading-overlay/ */

declare let Plotly: any;

import 'ag-grid-community';
import 'ag-grid-enterprise';

import {
  CellValueChangedEvent,
  ColumnVisibleEvent,
  GetContextMenuItemsParams,
  GridApi,
  GridReadyEvent
} from "ag-grid-community";
import {errorAsText} from "@/util/util";

@Component({
  selector: 'kpi-table-viewer-component',
  template: `
<div class="kpi-table-viewer-outer-wrapper" id="kpi-table-panel-{{u}}">

  <ul class="nav nav-pills" id="kpi-table-viewer-nav-tab-{{u}}">

    <li class="nav-item active"><a class="nav-link active" id="kpi-table-tab-{{u}}" data-toggle="tab" href="#kpi-table-{{u}}">Table</a></li>
    <li class="nav-item active"><a class="nav-link" id="kpi-graph-tab-{{u}}" data-toggle="tab" href="#kpi-graph-{{u}}" >Graph</a></li>
  </ul>

  <div class="tab-content clearfix kpi-table" id="kpi-table-{{u}}">
    <div class="tab-pane kpi-table-pane" id="kpi-table-pane-{{u}}">

      <ag-grid-angular
        id="ag-grid-kpi-table_{{u}}"
        style="width: 100%; height: 100%;"
        class="ag-theme-balham-dark ag-grid-kpi-table"
        [rowData]="rowData"
        [columnDefs]="defaultColDefs"
        [defaultColDef]="defaultColDef"
        [context]="context"
        [animateRows]="true"
        [enableRangeSelection]="true"
        [rowSelection]="'multiple'"

        [components]="components"

        [allowContextMenuWithControlKey]="true"
        [getContextMenuItems]="getContextMenuItems"

        (gridReady)="onGridReady($event)"
        (columnVisible)="onColumnVisible($event)"
        (cellValueChanged)="onCellValueChanged($event)"
      >
      </ag-grid-angular>

    </div>
  </div>

  <div class="tab-content clearfix kpi-graph" id="kpi-graph-{{u}}">
    <div class="tab-pane kpi-graph-pane" id="kpi-graph-pane-{{u}}">



    </div>
  </div>

</div>`
})

export class KPITableViewerComponent implements AfterViewInit {

  /* for making our #id's unique */

  public static  instanceNum: number = 0;
  public u: number = KPITableViewerComponent.instanceNum;

  /** the current KPI table being viewed */
  public tableFocus: string = '';
  public graphFocus: string = '';

  /** the KPI data the table is using */
  public kpiData: KPI[] = [];

  /** the KPI table that has been requested for viewing */
  public requested: string = '';

  /** the API for the widget */
  private          api: GridApi  = null;

  /** @var _graph the Plotly graphing area */
  private        graph:      any = null;

  private isFullScreen: boolean  = false;

  /** which columns are currently selected for display */
  private visibleColumns: string[] = [];

  public context = {

    kpitable: this

  };

  public defaultColDef = {
    sortable:  true,
    filter:    true,
    resizable: true
  };

  public rowData = [];

  public defaultColDefs: any = [
    {
      headerName: 'ID',
      field: 'id',
      editable: false,
      width: 32,
      hide: true
    },
    {
      headerName: 'Order',
      field: 'order',
      editable: true,
      hide: true,
      width: 32,
    },
    {
      headerName: 'Label',
      field: 'label',
      editable: true,
      width: 150,
    }
  ];

  public components = {
    numEditor: NumberEditor
  };

  /** standard constructor */
  constructor(
    private blobber: BlobService,
  ) {

    Logger.debug('[kpitableviewer] dynamically creating...');

  }

  public onGridReady(params: GridReadyEvent) {

    Logger.debug('[kpitableviewer] agGrid is ready for use.');

    this.api       = params.api;

    /* start with the agGrid (table) tab shown */

    // @ts-ignore
    $(`#kpi-table-${this.u}`).tab('show');

    const viewer = this;

    $(`#kpi-table-viewer-nav-tab-${this.u} a`).on('click', function (e) {
      e.preventDefault();

      viewer.resize();

      setTimeout(() => {

        viewer.plotlyRender(viewer.kpiData);

      }, 200);

    });

    /* load any pending KPI data */

    this.loadTable();
    this.loadGraph();
  }

  public onCellValueChanged(event: CellValueChangedEvent ): void {

    const value: any    = event.newValue;
    const index: number = event.data.id;
    const field: string = event.colDef.field;
    const   kpi: KPI    = this.kpiData[index];

    /* edit the KPI holder */

    if (field === 'label') {

      /* set the label for this scenario row */

      kpi.label = value;

    } else if(kpi.fields().includes(field)) {

      /* set the metric */

      kpi.metrics.set(field, value);
    }

    /* re-save the KPI table blob ... */

    const viewer: KPITableViewerComponent = this;

    viewer.blobber.update(viewer.requested, JSON.stringify(this.kpiData))
      .pipe(first())
      .subscribe(
        {
          next: (): void => {

            Logger.debug(`[kpitableviewer] saved KPI table. `, viewer.requested);

            /* tell the graph to also update */

            this.plotlyRender(this.kpiData);

          },
          error: (err): void => {

            Logger.error(`[kpitableviewer] could not (re)save KPI table JSON: `, errorAsText(err));
          }
        });
  }

  public onColumnVisible(event: ColumnVisibleEvent) {

    /* figure out which columns are were shown/hidden */

    const visible: boolean = event.visible;
    const change: string[] = event.columns.map(x => x.getColDef().field);

    /* update our tracking of visible columns... */

    if (visible === false) {

      /* remove from visible list */

      this.visibleColumns = this.visibleColumns.filter(x => !change.includes(x));

    } else {

      /* add to visible list */

      this.visibleColumns =  this.visibleColumns.concat(change);

      this.visibleColumns =  this.visibleColumns.filter((x, pos) =>  this.visibleColumns.indexOf(x) === pos)
    }

    /* tell the graph to redraw (with the new columns */

    this.plotlyRender(this.kpiData);
  }

  public toggleFullScreen() {

    if (this.isFullScreen) {

      Logger.debug('[kpitableviewer]', 'exiting full screen...');

      document.exitFullscreen();

      this.isFullScreen = false;

      setTimeout(() => {

        this.plotlyRender(this.kpiData);

      }, 200);

    } else {

      Logger.debug('[kpitableviewer]', 'going full screen...');

      const elem = document.getElementById(`kpi-table-panel-${this.u}`);

      if (elem.requestFullscreen) {

        elem.requestFullscreen();
      }

      this.isFullScreen = true;

      setTimeout(() => {

        this.plotlyRender(this.kpiData);

      }, 200);

    }

  }

  public getContextMenuItems(params: GetContextMenuItemsParams): any {

    const context: any[]   = [];

    /* full screen control */

    const viewer: KPITableViewerComponent  = params.context.kpitable;
    let   label:                    string = 'Show Full Screen';

    if (viewer.isFullScreen) {

      label = 'Exit Full Screen';
    }

    context.push( {
      name: label,
      action: () => {

        viewer.toggleFullScreen();
      }
    });

    context.push('separator');

    const general: any[] = [

      'csvExport',
      'excelExport',
      'excelXmlExport',

      'separator',

      'autoSizeAll'
    ];

    /* pass back the merged menu */

    context.push.apply(context, general);

    return context;
  }

  ngAfterViewInit(): void {

    Logger.debug(`[kpitableviewer] init (instance = ${this.u})...`);

    this.u = KPITableViewerComponent.instanceNum++;

    /* setup is complete */

  }


  public resize() {

    if(this.graph === null) {

      /* there is no graph yet. */

      return ;
    }

    const hostElement: JQuery      =  $(`#kpi-graph-pane-${this.u}`);
    const         dom: HTMLElement = hostElement.get()[0];
    const       width: number      = $(dom).width();
    const      height: number      = $(dom).height();

    /* update plotly drawing area geometry */

    if ((dom === null) || (typeof dom === 'undefined')) {

      /* nothing to do yet */

      return ;
    }

    if (width < 200) {

      /* to small */

      return ;
    }

    if (height < 200) {

      /* too small */

      return ;
    }

    let update: {width: number, height: number} = {
      width,
      height
    };

    try {

      setTimeout( () => {

        // noinspection JSUnresolvedReference
        Plotly.relayout(dom, update);

        }, 200);

    } catch (e) {

      Logger.error(`[kpitableviewer] Plotly resize error: `, e);
    }
  }

  /* set up the table and graph with the given KPI data (a kpi table blob) */
  public load(key: string) {

    Logger.debug(`[kpitableviewer] loading table: `, key);

    this.requested = key;

    this.loadTable();

    this.loadGraph();

  }

  /** helper to set up the table with the given KPI series */
  public agGridRender(kpi: KPI[]) {

    this.kpiData = kpi;

    /* scan for all possible fields, we don't know ahead of time what the fields are */

    /* key value: whethor we are showing this column or not */

    const defaultShow: string[] = [
      "Industry Speed",
      "Network Speed",
      "Average Delay per 100 Miles"
    ];

    this.visibleColumns = defaultShow;

    const fields: Map<string, boolean> = new Map<string, any>();

    kpi.forEach((item: KPI, index) => {

      item.fields().forEach( (field: string) => {

        /* is this one of the by-default-interesting columns? */

        fields.set(field, false);

      });

      /* if no ordering has been set, then just default to the order we process them in */

      if (item.order === 0) {

        item.order = index + 1;
      }

    });

    for (const k of fields.keys()) {

      if (defaultShow.indexOf(k) >= 0) {

        fields.set(k, true);
      }
    }

    /* with all the fields known, we can re-define the columns of the table */

    /* start with the fixed columns we know have to be there */

    const cd: any[] = [].concat([], this.defaultColDefs);

    /* add in each dynamic field, not all KPIs may have every field */

    for(const field of fields.keys()) {

      cd.push({
        headerName: field,
        field:      field,
        editable:   true,
        hide:       !fields.get(field),
        width:      180,
        cellEditor: 'numEditor',
        cellRenderer: NumberRenderer,
      });

    }

    /* ok, we can now tell agGrid what our columns are ... */

    this.api.setGridOption('rowData',    []);
    this.api.setGridOption('columnDefs', cd);

    /* now with the columns defined, we can add a row for each KPI holder ... */

    this.rowData = [];

    let row: number = 0;

    for (const kpi of this.kpiData) {

      /* row def starts with the fixed columns */

      const rd: any = {
        id: row,
        order: kpi.order,
        label: kpi.label,
      };

      /* add in dynamic columns */

      for (const field of fields.keys()) {

        rd[field] = kpi.value(field);
      }

      this.rowData.push(rd);

      row++;
    }

    /* set the row data (fill the table) */

    this.api.setGridOption('rowData', this.rowData);

  }

  /** helper to set up the graph with the given KPI series */
  public plotlyRender(kpi: KPI[]) {

    const hostElement: JQuery      =  $(`#kpi-graph-pane-${this.u}`);
    const         dom: HTMLElement = hostElement.get()[0];
    const       width: number      = dom.clientWidth;
    const      height: number      = dom.clientHeight;

    if ((width === 0) || (height === 0)) {

      /* currently hidden */

      return ;
    }

    $(hostElement).html();

    const layout = {
      autosize: true,
      paper_bgcolor: '#0d0d21',
      plot_bgcolor: '#0d0d21',
      dragmode: 'pan',
      hovermode: 'closest',
      title: `KPI Table`,
      font: {
        size: 12
      },
      yaxis: {
        color: '#f6f6f6',
        spikemode: 'across',
        spikethickness: 1,
        spikedash: 'dash',
        spikecolor: '#e4e4e4',
        showgrid: true,
        gridwidth: 1,
        automargin: true
      },
      xaxis: {
        color: '#f6f6f6',
        title: 'Metrics',
        ticks: '',
        showticklabels: false,
        spikemode: 'across',
        spikethickness: 1,
        spikedash: 'dash',
        spikecolor: '#e4e4e4',
        showgrid: true,
        gridwidth: 1
      }

    };

    const xLabels: string[] = kpi.map(x => x.label);
    const    data: any[]    = [];

    this.visibleColumns.forEach((field: string) => {

      const yValues: number[] = kpi.map(x => x.metrics.get(field));

      data.push({
           x: xLabels,
           y: yValues,
        name: field,
        type: 'bar'
      });

    });

    // noinspection JSUnresolvedReference
    this.graph = Plotly.newPlot(dom, data, layout, {
      responsive: true,
      scrollZoom: true,
      watermark: false,
      logging: 1
    });

    /* set the initial geometry (even thought It's not initially visible) */

    let update: {width: number, height: number} = {
      width,
      height
    };

    // noinspection JSUnresolvedReference
    Plotly.relayout(dom, update);

  }

  /** set up the table */
  public loadTable() {

    if (this.api === null) {

      /* not ready yet. */

      return ;
    }

    if (this.tableFocus === this.requested) {

      /* already loaded */

      return ;
    }

    Logger.debug(`[kpitableviewer:table] setting up...`);

    const viewer: KPITableViewerComponent = this;

    viewer.blobber.contents(viewer.requested)
      .pipe(first())
      .subscribe(
        {
          next: (content: string): void => {

            const   tData:  any = JSON.parse(content);
            const kpiData: KPI[] = [];

            tData.forEach((item: any) => {

              kpiData.push(new KPI(item));

            });

            Logger.debug(`[kpitableviewer:table] KPI data`, kpiData);

            /* table setup */

            this.agGridRender(kpiData);

            /* rendering complete */

            viewer.tableFocus = viewer.requested;
          },
          error: (err): void => {

            Logger.error(`[kpitableviewer:table] can't find KPI table content ${viewer.requested}: `, errorAsText(err));
          }
        });

  }

  /** set up the graph */
  public loadGraph() {

    if (this.api === null) {

      /* not ready yet. */

      return ;
    }

    if (this.graphFocus === this.requested) {

      /* already loaded */

      return ;
    }

    Logger.debug(`[kpitableviewer:graph] setting up...`);

    const viewer: KPITableViewerComponent = this;

    viewer.blobber.contents(viewer.requested)
      .pipe(first())
      .subscribe({
        next: (content: string): void => {

          const gData: any = JSON.parse(content);
          const kpiData: KPI[] = [];

          gData.forEach((item: any) => {

            kpiData.push(new KPI(item));

          });

          Logger.debug(`[kpitableviewer:table] KPI data`, kpiData);

          /* graph setup */

          this.plotlyRender(kpiData);

          /* rendering complete */

          viewer.graphFocus = viewer.requested;
        },

        error: (err) => {

          Logger.error(`[kpitableviewer:graph] can't find KPI table content ${viewer.requested}: `, errorAsText(err));
        }

      });

  }
}
